var _excluded = ["title", "children", "className"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { useRef, useState } from 'react';
import Button from "../Button/Button";
import Icon from "../Icon/Icon";
import Popover from "../Popover/Popover";
import PopoverBody from "../Popover/PopoverBody";
import PopoverHeader from "../Popover/PopoverHeader";
var count = 0;

function getID() {
  return "help-bubble-".concat(count++);
}

var style = {
  cursor: 'pointer'
};

function HelpBubble(props) {
  var idRef = useRef();

  if (!idRef.current) {
    idRef.current = getID();
  }

  var id = idRef.current;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var toggle = function toggle(e) {
    e.stopPropagation();
    setIsOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });
  };

  var title = props.title,
      children = props.children,
      className = props.className,
      other = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement("span", {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(Button, {
    color: "link",
    className: "p-0",
    "aria-label": "More Info",
    onClick: toggle
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "question-circle",
    id: id,
    className: "text-primary"
  })), /*#__PURE__*/React.createElement(Popover, _extends({
    isOpen: isOpen,
    toggle: toggle,
    target: id
  }, other), /*#__PURE__*/React.createElement("div", {
    "aria-live": "polite"
  }, title && /*#__PURE__*/React.createElement(PopoverHeader, null, title), /*#__PURE__*/React.createElement(PopoverBody, null, children))));
}

HelpBubble.displayName = "HelpBubble";
export default HelpBubble;